import { useEffect, useState } from 'react';
import { Button } from '../../../../components/Button';

interface IFixedCTA {
  cta: string | undefined;
  show: boolean;
}

export function FixedCTA({ cta, show }: IFixedCTA) {
  const [isShowFixedCTA, setIsShowFixedCTA] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      const element = document.getElementById('form-conversion');
      const rect = element ? element.getBoundingClientRect() : null;
      if (rect) {
        if (rect?.top >= 0 && rect?.top <= 200) {
          setIsShowFixedCTA(false);
        } else {
          setIsShowFixedCTA(true);
        }

        if (rect?.top <= 200 && rect?.top >= -300) {
          setIsShowFixedCTA(false);
        } else {
          setIsShowFixedCTA(true);
        }
      }
    });
  }, []);

  return (
    <>
      {show && (
        <>
          {isShowFixedCTA && (
            <div className="fixed-bottom d-block d-md-none">
              <div className="container bg-light p-3">
                <div className="container">
                  <div className="d-flex">
                    <div className="d-flex container-fluid align-items-center">
                      <i className="material-icons-outlined me-3">feed</i>
                      <p className="m-0 fw-semibold">{cta}</p>
                    </div>
                    <div className="d-flex container-fluid flex-row-reverse">
                      <Button
                        text="Enviar dados"
                        color="primary"
                        icon="check_circle"
                        onClick={(e) => {
                          const element =
                            document.getElementById('form-conversion');
                          e.preventDefault();
                          element && element.scrollIntoView();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
